<div class="main-page-container">
  <div class="sticky-top">
    <div class="title-container padding-x">
      <p class="title mb-0">Create Itinerary</p>
    </div>

    <div class="navbar-list-container padding-x">
      <div class="item">
        <p class="link">Trip Details</p>
      </div>
      <div class="item">
        <p class="link">AI Route Plan</p>
      </div>
      <div class="item">
        <p class="link">Hotels</p>
      </div>
      <div class="item">
        <p class="link active">Vehicles</p>
      </div>
      <div class="item">
        <p class="link">Review</p>
      </div>
      <div class="item">
        <p class="link">Pricing</p>
      </div>
      <div class="item">
        <p class="link">Payment</p>
      </div>
      <div class="item">
        <p class="link">Confirmation</p>
      </div>
    </div>
  </div>

  <div class="page-main-section padding-x pt-4">
    <div class="">
      <img src="assets/Images/tgts/vehicles-selection.png" alt="" class="w-100">
    </div>
  </div>

  <div class="footer-main-container">
    <div class="d-flex justify-content-center">
      <!-- <ion-button class="unfilled-blue-btn">Share For Feedback</ion-button> -->
      <ion-button class="filled-blue-btn submit-btn" (click)="onSubmit()">Continue To Review</ion-button>
    </div>
  </div>
</div>